import { render, staticRenderFns } from "./purchaserDb.vue?vue&type=template&id=26080d66&scoped=true"
import script from "./purchaserDb.vue?vue&type=script&lang=js"
export * from "./purchaserDb.vue?vue&type=script&lang=js"
import style0 from "./purchaserDb.vue?vue&type=style&index=0&id=26080d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26080d66",
  null
  
)

export default component.exports